import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { ClientStatisticsByYear } from '@classes/client-statistics/client-statistics-by-year';
import { ImageService } from '@services/image.service';
import { UiKpiService } from 'app/shared/kpi/core/services/ui-kpi.service';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-crm-chart-by-year',
  styleUrls: ['./crm-chart-by-year.component.scss'],
  template: `
  <div class="crm-chart-by-year">
    <canvas #chartCanvas style="height: 300px ;"></canvas>
  </div>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onDownloadClick()">
      <mat-icon>download</mat-icon>
      {{ 'global.button.download' | translate }}
    </button>
  </mat-menu>
  `
})
export class CRMChartByYearComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('chartCanvas') chartCanvas: ElementRef | any;
  @Input() clientStatisticsByYear: ClientStatisticsByYear[] = [];

  private _chart: Chart;
  private _charBase64!: string;
  colors: string[] | any;

  constructor(
    private _uiSrv: UiKpiService,
    private _imageSrv: ImageService,
  ) {
    this.colors = this._uiSrv.getChartsColors();
  }

  public ngAfterViewInit(): void {
    this._initializeChart();
  }

  public ngOnChanges(): void {
    this._updateChart();
  }

  private _updateChart(): void {
    if (this._chart) {
      this._chart.data = this._generateChartData();
      this._chart.update();
    }
  }

  public ngOnDestroy(): void {
    if (this._chart)
      this._chart.destroy();
  }

  private _initializeChart(): void {
    this._chart = new Chart(this.chartCanvas.nativeElement, {
      type: 'bar',
      data: this._generateChartData(),
      options: {
        plugins: {
          title: {
            display: true,
            text: "Nombre de courses par an"
          },
        },
        animation: {
          onComplete: () => {
            this._charBase64 = this._chart.toBase64Image();
          },
        },
      },
    });
  }

  private _generateChartData() {
    const labels = this.clientStatisticsByYear.map(stat => stat.year);
    const datasets = [this._generateNumberOfOrdersDataset()];

    return {
      labels,
      datasets
    }
  }

  private _generateNumberOfOrdersDataset() {
    const label = "Nombre de courses";
    const data = this.clientStatisticsByYear.map(stat => stat.numberOfOrders);

    return this._buildDataset(label, data, this.colors[0]);
  }

  private _buildDataset(label: string, data: number[], backgroundColor: string) {
    return {
      label,
      data,
      backgroundColor,
      borderWidth: 1
    }
  }

  public onDownloadClick(): void {
    if (this._charBase64) {
      let chartName = 'chart-par-an';

      this._imageSrv.downloadBase64File(
        this._charBase64,
        chartName
      );
    }
  }
}